<template>
  <div class="prescription-container">
    <!-- 当前用户为患者&&订单状态为1时才显示倒计时 -->
    <div class="payment-countdown" v-if="dataDone && userInfo.role == 2 && scriptData.order_status == 1">支付倒计时
      <van-count-down class="countdown" :time="leftTime" @finish="changeOrderStatus" />，72小时内未支付，订单将自动取消</div>
    <div class="prescription-back" :class="{'top': scriptData.order_status != 1 || userInfo.role == 1}"></div>
    <div class="prescription-main" v-if="dataDone">
      <prescription :script-data="scriptData" :role="userInfo.role" :is-pay="(scriptData.order_status == 3 || scriptData.order_status == 4) ? true : false"
        :from="'card'"></prescription>
      <!-- 医生显示返回按钮 -->
      <div class="back" v-if="userInfo.role == 1"><button class="back-button" @click="back">返回</button></div>
      <!-- 患者需判断订单状态显示对应操作 -->
      <div class="patient-script-control" :class="{'has-pay-button': scriptData.order_status == 1}" v-else>
        <address-picker :address-data="addressData" :read-only="scriptData.order_status != 1 ? true : false" v-if="scriptData.order_status != 2"
          @picked="confirmAddress" />
        <div class="script-price-container">
          <div class="normal-price">
            <!-- 只显示总价，注释掉
            <div class="price-item">
              <div class="type">药材费</div>
              <div class="price">¥ {{scriptData.normalPrice.toFixed(2)}}</div>
            </div>
            -->
            <!-- 处方剂型为中药饮片并且不代做膏方时才显示代煎选项 -->
            <!-- 待支付时显示选项 -->
            <div class="price-item" v-if="scriptData.type == 1 && parseFloat(scriptData.paste_price) == 0 && scriptData.order_status == 1&&ondecotionArea">
              <div class="type">代煎药方<span>*</span></div>
              <div class="price">
                <div class="selector">
                  <div class="selector-item" :class="{'selected': selectedDecoction == 1}" @click="selectDecoction(1)">是</div>
                  <div class="selector-item" :class="{'selected': selectedDecoction == 2}" @click="selectDecoction(2)">否</div>
                </div>
              </div>
            </div>

            <div class="price-item" v-if="selectedDecoction == 1&&ondecotionArea">
              <div class="type">代煎费用</div>
              <div class="price">¥ {{decoctionMoeny.toFixed(2)}}</div>
            </div>
            <div class="price-item" v-if="scriptData.type == 1 && scriptData.order_status == 1&&!ondecotionArea">
              <div class="type"></div>
              <div class="text-tip">您所在的区域不支持代煎药方</div>

            </div>
            <!--
            <div class="price-item">
              <div class="type">运费</div>
              <div class="price" :class="{'zero': expressPrice == 0}">¥ {{expressPrice.toFixed(2)}}</div>
            </div>
            -->
          </div>
          <div class="total-price">
            <div class="type">费用合计</div>
            <div class="price">¥ {{totalPrice | int}}<span>{{totalPrice | float}}</span></div>
          </div>
        </div>
        <div class="invalid-tips" v-if="scriptData.order_status == 2">订单已失效，如有疑问请<a :href="`tel:${serviceNumber}`">联系喜乐医生客服</a></div>
        <div class="fixed-pay" v-if="scriptData.order_status == 1">
          <div class="payment-info">实付<span>¥ {{totalPrice.toFixed(2)}}</span></div>
          <button class="pay-button" @click="orderPay" :disabled="paying">去支付</button>
        </div>
        <div class="back" v-else><button class="back-button" @click="back">返回</button></div>
      </div>
      <!-- <div class="check-card" v-else>
        <div class="check-box">
          <icon icon-class="review"></icon>
          <div class="check-text">
            <h4>医生正在为您开方...</h4>
            <p>请稍后查看</p>
          </div>
        </div>
        <div class="check-back"><button class="check-back-button" @click="back">返回</button></div>
      </div> -->
    </div>
    <status-dialog v-if="invalidOrderShow" status-type="error" title="订单失效" sub-title="订单支付超时，感谢您的理解！" @close="invalidOrderShow = false"></status-dialog>
  </div>
</template>

<style lang="less" scoped>
  .prescription-container{
    min-height: 100vh;
    background: #F7F7F7;
    .payment-countdown{
      width: 100%;
      height: 32px;
      background: #F5A41E;
      color: #FFF;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      .countdown{
        color: #FFF;
        margin: 0 4px;
        font-weight: bold;
        font-size: 15px;
      }
    }
    .prescription-back{
      position: absolute;
      top: 32px;
      left: 0;
      width: 100%;
      height: 184px;
      background: @linear;
      &.top{
        top: 0;
      }
    }
    .prescription-main{
      position: relative;
      padding: 0 8px 12px;
      z-index: 10;
      .back{
        margin-top: 24px;
        .back-button{
          @button-base();
          width: 100%;
          height: 40px;
        }
      }
      .patient-script-control{
        &.has-pay-button{
          padding-bottom: 60px;
        }
        .script-price-container{
          margin-top: 12px;
          background: #FFF;
          border-radius: 6px;
          padding: 32px 16px;
          .normal-price{
            padding-bottom: 20px;
            .price-item{
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 29px;
              &:last-child{
                margin-bottom: 0;
              }
              .text-tip{
                font-size: 13px;
                line-height: 16px;
                color: #666;
                font-weight: bold;
              }
              .type{
                font-size: 16px;
                line-height: 16px;
                color: @black;
                font-weight: bold;
                span{
                  color: @error;
                }
              }
              .price{
                font-size: 16px;
                line-height: 16px;
                color: #666;
                font-weight: bold;
                &.zero{
                  color: #999;
                }
                .selector{
                  display: flex;
                  justify-content: flex-end;
                  align-items: center;
                  .selector-item{
                    height: 32px;
                    padding: 0 20px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border: 1px solid #E0E6E6;
                    background: #F7F7F7;
                    color: #999;
                    font-size: 14px;
                    cursor: pointer;
                    border-radius: 4px;
                    transition: all .1s;
                    &:first-child{
                    margin-right: 16px;
                    }
                    &.selected{
                      border-color: @xile;
                      background: @xile;
                      color: #FFF;
                    }
                  }
                }
              }
            }
          }
          .total-price{
            border-top: 1px solid #EEE;
            padding-top: 28px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .type{
              font-size: 20px;
              line-height: 20px;
              color: @black;
              font-weight: bold;
            }
            .price{
              font-size: 24px;
              line-height: 24px;
              color: @xile;
              font-weight: bold;
              span{
                font-size: 18px;
              }
            }
          }
        }
        .invalid-tips{
          text-align: center;
          margin-top: 24px;
          font-size: 14px;
          line-height: 14px;
          color: #999;
          a{
            color: @xile;
            text-decoration: underline;
          }
        }
        .fixed-pay{
          position: fixed;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 48px;
          background: #FFF;
          display: flex;
          justify-content: space-between;
          align-items: center;
          z-index: 20;
          .payment-info{
            padding-left: 24px;
            font-size: 16px;
            color: @black;
            font-weight: bold;
            span{
              margin-left: 12px;
              font-size: 20px;
              color: @xile;
            }
          }
          .pay-button{
            @button-base();
            width: 144px;
            height: 100%;
            border-radius: 0;
          }
        }
      }
      .check-card{
        padding: 45px 16px 12px;
        background: #FFF;
        border-radius: 4px;
        margin-top: 12px;
        .check-box{
          display: flex;
          justify-content: center;
          align-items: center;
          svg{
            font-size: 44px;
          }
          .check-text{
            padding-left: 12px;
            h4{
              font-size: 17px;
              line-height: 17px;
              color: @xile;
              font-weight: normal;
            }
            p{
              margin-top: 8px;
              font-size: 14px;
              line-height: 14px;
              color: #666;
            }
          }
        }
        .check-back{
          margin-top: 40px;
          button{
            @button-base();
            @button-border();
            width: 100%;
            height: 40px;
            border-radius: 6px;
            font-size: 15px;
          }
        }
      }
    }
  }
</style>

<script type="text/javascript">
  import prescription from '@/components/Common/prescription'
  import addressPicker from '@/components/Common/addressPicker'
  import statusDialog from '@/components/Common/statusDialog'
  export default {
    data() {
      return {
        scriptId: this.$route.params.id,
        dataDone: false,
        leftTime: 0,
        scriptData: {},
        // 用户选择地址数据
        addressData: {
          address_id: null,
          name: '',
          mobile: '',
          province: '',
          city: '',
          country: '',
          region: '',
          address: ''
        },
        decoctionArea: null,
        // 运费
        expressPrice: 0,
        // 是否代煎
        selectedDecoction: 2,
        // 代煎费用
        decoctionMoeny: 0,
        // 防止按钮多次点击
        paying: false,
        // 订单过期弹窗
        invalidOrderShow: false,
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      },
      serviceNumber() {
        return this.$store.state.servicePhone;
      },
      ondecotionArea() {
        let flag = false;
        if (this.decoctionArea != null&&this.scriptData.type == 1) {
            for (var i = 0; i < this.decoctionArea.length; i++) {
              var item=this.decoctionArea[i].province;
              if (this.addressData.province && item == this.addressData.province) {
                flag = true;
                break;
              } else if (this.addressData.address.indexOf(item) != -1) {
                console.log(this.addressData.address + "indexOf" + item)
                flag = true;
                break;
              }
              console.log(item)
            }
          } else {
            flag = false;

          }
          return flag;
        },
        totalPrice() {
          let deciction = this.selectedDecoction == 1 ? this.decoctionMoeny : 0;
          if (this.scriptData.normalPrice) {
            return this.scriptData.normalPrice + deciction; //+ this.expressPrice 去掉运费
          } else {
            return 0;
          }
        }
      },
      components: {
        prescription,
        addressPicker,
        statusDialog
      },
      created() {
        this.$root.post('/getPreDetail', {
          id: this.scriptId,
          type: this.userInfo.role
        }).then(data => {
        console.log(data)
          this.dataDone = true;
          if (data && data.end_time) {
            let now = new Date().getTime() / 1000;
            this.leftTime = (data.end_time - now) * 1000;
          }
          if (data.address) {
            this.addressData = data.address;
            console.log(this.addressData)
          }
          this.selectedDecoction = data.is_decoction;
          data.normalPrice = data.price / 100 || 0;
          // data.normalExpressage = data.expressage / 100 || 0;
          // this.expressPrice = data.normalExpressage;

          this.scriptData = data;
          // 获取代煎费
          this.$root.post('/getDecoctionPrice').then(res => {

            // 代煎费=代煎费单剂价格 * 处方剂量
            this.decoctionMoeny = (res.decoction_price * data.dose) / 100;
            // 如果已选择过代煎服务，则减去代煎服务的价格，还原药方原价
            if (this.selectedDecoction == 1) {
              this.scriptData.normalPrice = this.scriptData.normalPrice - this.decoctionMoeny;
            }
            // 如果有已选地址回显，则减去运费还原药方原价
            if (this.scriptData.normalExpressage) {
              this.scriptData.normalPrice = this.scriptData.normalPrice - this.scriptData.normalExpressage;
            }
            this.decoctionArea = JSON.parse(res.decoction_area);
          })

        })
        // 获取微信sdk签名
        let url = encodeURIComponent(window.location.href.split('#')[0])
        this.$root.post('/getJsSdk', {
          // url: `${window.location.protocol}//${window.location.host}/`
          url: url
        }).then(data => {
          if (data) {
            wx.config({
              debug: this.$store.state.wechatDebug,
              appId: data.appId,
              timestamp: data.timestamp,
              nonceStr: data.nonceStr,
              signature: data.signature,
              jsApiList: ['chooseWXPay']
            });
          }
        })
      },
      methods: {
        // 倒计时结束后自动将待支付的订单状态变为已失效
        changeOrderStatus() {
          if (this.scriptData.order_status == 1) {
            this.scriptData.order_status = 2;
          }
        },
        // 选择是否代煎
        selectDecoction(type) {
          this.selectedDecoction = type;
        },
        confirmAddress(address) {
          // 获取地址id请求运费数据
          this.addressData = address;
          this.$root.post('/getExpressage', {
            address_id: this.addressData.address_id
          }).then(data => {
            if (data != 0) {
              //this.expressPrice = data / 100;
            }
          })
        },
        // 支付订单
        orderPay() {
          if (!this.addressData.address_id) {
            
            this.$notify('请添加收货地址');
            return;
          }
          console.log(this.selectedDecoction)
          if(this.selectedDecoction == 0){
            this.selectedDecoction = 2
          }
          // 如果是不代做膏方的饮片没有选择代煎选项时弹出提示
          if (this.selectedDecoction == 0 && this.scriptData.type == 1 && parseFloat(this.scriptData.paste_price) == 0) {
            this.$notify('请选择是否代煎药方');
            return;
          }
          this.paying = true;
          this.$root.post('/orderPay', {
            order_id: this.scriptData.order_id,
            address_id: this.addressData.address_id,
            is_decoction: this.selectedDecoction,
          }).then(data => {
            let _this = this;
            if (data.status == 1) {
              // 调用微信支付接口
              wx.chooseWXPay({
                timestamp: data.info.timestamp,
                nonceStr: data.info.nonceStr,
                package: data.info.package,
                signType: data.info.signType,
                paySign: data.info.paySign,
                success(res) {
                  console.log(res);
                  _this.paying = false;
                  if (res.errMsg == 'chooseWXPay:ok') {
                    _this.$router.push({
                      path: '/patient/order/success',
                      query: {
                        order_number: _this.scriptData.number,
                        type: 2,
                        order_id: _this.scriptData.order_id
                      }
                    })
                  } else if (res.errMsg == 'chooseWXPay:cancel') {
                    _this.$notify('您已取消支付');
                  } else if (res.errMsg == 'chooseWXPay:fail') {
                    _this.$notify('支付出错，请稍后再试');
                  }
                },
                cancel(res) {
                  _this.paying = false;
                  _this.$notify('您已取消支付');
                },
                fail(res) {
                  _this.paying = false;
                  _this.$notify('支付出错，请稍后再试');
                },
              })
            } else if (data.status == 2) {
              _this.paying = false;
              _this.invalidOrderShow = true;
            } else {
              _this.paying = false;
              _this.$notify(data.msg);
            }

          })
        },
        back() {
          this.$router.go(-1);
        }
      }
    }
</script>



// WEBPACK FOOTER //
// src/components/Public/prescriptionPaper.vue